import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { notify } from '../../../util/notifications';
import ResponseTimeCtrl from '../../../components/reportsComponents/summaries/responseTimeCtrl';
import ResponseTimeTable from '../../../components/reportsComponents/summaries/responseTimeTable';
import { initResponseState } from '../../../util/stateUtil/initialStateForComponents';
import { resColumns } from '../../../util/tableColumnUtil/summaryClms';
import { fetchAllDriverList } from '../../../actions/reportAction/allinvoice/allinvoice';
import { isManagement, getCompanyId } from '../../../util/customMethods';
import { getResponseReport, cleanResponseReport, emailResponseReport } from '../../../actions/reportAction/summaryAction/summary';
import { isValidForm } from '../../../util/validationMethods';
import printJS from 'print-js';
const pageTitle = 'Response Time Report';
const printJSHeaders = resColumns.map(column => ({
    field: column.accessor,
    displayName: column.Header || column.accessor
}))
let ReportForm = {};

class ResponseTime extends Component {
    state = {
        ...initResponseState
    }

    Go = async () => {
        const { dispatch } = this.props;
        let status = false;
        let payload = this.buildObject();
        if (payload) {
            if (isManagement() && (this.state.idCompany || 0) == 0) {
                status = true;
            }
            const res = await dispatch(getResponseReport(payload, status));
            if (res.statusCode === 200) {
                notify.createNotification('success', res.statusMsg, this.props.refNotify);
                this.setState({ render: false });
            } else {
                notify.createNotification('error', res.statusMsg, this.props.refNotify);
            };
        }
    }

    Export = async () => {
        const { dispatch } = this.props;
        let status = false;
        let payload = this.buildObject();
        if (payload) {
            if (isManagement() && (this.state.idCompany || 0) == 0) {
                status = true;
            }
            const res = await dispatch(getResponseReport(payload, status));
            if (res.statusCode === 200) {
                this.setState({ render: !this.state.render });
                notify.createNotification('success', 'Report exported successfully.', this.props.refNotify);
                this.setState({ render: false });
            } else {
                this.setState({ render: false });
                notify.createNotification('error', res.statusMsg, this.props.refNotify);
            };
        }
    }

    Print = async () => {
        const { dispatch } = this.props;
        let status = false;
        let payload = this.buildObject();
        if (payload) {
            if (isManagement() && (this.state.idCompany || 0) == 0) {
                status = true;
            }
            const res = await dispatch(getResponseReport(payload, status));
            if (res.statusCode === 200) {
                printJS({
                    printable: this.props.responseReport || [],
                    properties: printJSHeaders,
                    type: 'json',
                    documentTitle: 'Response Time Report'
                });
            } else {
                notify.createNotification('error', res.statusMsg, this.props.refNotify);
            };
        }
    }

    Email = async () => {
        const { dispatch } = this.props;
        let status = false;
        let payload = this.buildObject();
        if (payload) {
            if (isManagement() && (this.state.idCompany || 0) == 0) {
                status = true;
            }
            const res = await dispatch(emailResponseReport(payload, status));
            if (res.statusCode === 200) {
                notify.createNotification('success', res.statusMsg, this.props.refNotify);
            } else {
                notify.createNotification('error', res.statusMsg, this.props.refNotify);
            };
        }
    }

    /* Building all invoice object for post request */
    buildObject = () => {
        const stateObj = this.state;
        const constractObj = {
            idCompany: isManagement() ? (this.state.idCompany || getCompanyId()) : getCompanyId(),
            fromDate: stateObj.fromDate,
            toDate: stateObj.toDate,
            accountId: stateObj.accountId,
            name: "reason",
            empId: stateObj.empId,
            lateOnly: stateObj.lateOnly
        };
        return constractObj;
    }

    componentWillMount = () => {
        document.title = pageTitle;
        this.props.dispatch(fetchAllDriverList());
        this.props.dispatch(cleanResponseReport());
    }
    onResponseTimeFieldChange = (key, value) => {
        this.setState({ [key]: value });
    }
    render() {
        let stateObj = this.state;
        return (
            <Fragment>
                <div className="page-header">
                    <div className="row mb-10">
                        <div className="col-md-12 col-sm-12">
                            <div className="title">
                                <h4> Response Time Report</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pd-10 bg-white border-radius-4 box-shadow">
                    <ResponseTimeCtrl
                        Go={() => {
                            ReportForm.validateAll()
                            if (isValidForm(ReportForm)) {
                                this.Go();
                            }
                        }}
                        Export={() => {
                            ReportForm.validateAll()
                            if (isValidForm(ReportForm)) {
                                this.Export();
                            }
                        }}
                        Email={() => {
                            ReportForm.validateAll()
                            if (isValidForm(ReportForm)) {
                                this.Email();
                            }
                        }} Print={() => {
                            ReportForm.validateAll()
                            if (isValidForm(ReportForm)) {
                                this.Print();
                            }
                        }}
                        stateObj={stateObj}
                        accountList={this.props.accountList}
                        childCompList={this.props.childCompList}
                        allInvoiceObj={this.props.allInvoiceObj}
                        data={this.props.responseReport || []}
                        onResponseTimeFieldChange={(key, value) => this.onResponseTimeFieldChange(key, value)}
                        initCallBack={(frm) => {
                            ReportForm = frm;
                        }} fromdate={this.state.fromDate} todate={this.state.toDate} />
                    <ResponseTimeTable
                        data={this.props.responseReport || []}
                        cols={resColumns} />
                </div>
            </Fragment>
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        refNotify: state.refNotify,
        accountList: state.invoiceInfo.accountList,
        childCompList: state.searchInvoiceList.childComList,
        allInvoiceObj: state.allInvoice,
        responseReport: state.summaryObj.responseReport
    }
};

export default withRouter(connect(mapStateToProps)(ResponseTime));
